import React, { useContext } from 'react';
import { Form, Field } from 'react-final-form';
import { TextField } from 'final-form-material-ui';
import { Grid, Button, CircularProgress } from '@material-ui/core';
import toast from 'react-hot-toast';
import emailjs from 'emailjs-com';
import FeedbacksContext from '../contexts/FeedbacksContext';
import siteConfig from '../siteConfig';

const validate = (values) => {
  const errors = {};
  if (!values.name) {
    errors.name = 'Please enter your name';
  }
  if (!values.testimonial) {
    errors.testimonial = 'Please tell us about your experience';
  }
  return errors;
};

export default function FeedbackForm({ onSuccess }) {
  const { addFeedback } = useContext(FeedbacksContext);

  const onSubmit = async (values, form) => {
    const data = {
      feedbackName: values.name,
      feedback: values.testimonial,
      show: false,
    };

    try {
      await addFeedback(data);
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_FEEDBACKS_TEMPLATE_ID,
        data,
        process.env.REACT_APP_EMAILJS_USER_ID
      );
      toast.success('Thank you for your review!');
      setTimeout(() => form.restart());
      if (onSuccess) onSuccess();
    } catch (e) {
      console.error('Error submitting feedback: ', e);
      toast.error(`Sorry, your review didn't go through. Please try again or text us at ${siteConfig.phoneDisplay}.`);
    }
  };

  return (
    <Form
      onSubmit={onSubmit}
      validate={validate}
      render={({ handleSubmit, submitting }) => (
        <form onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Field
                fullWidth
                required
                name="name"
                component={TextField}
                variant="outlined"
                type="text"
                label="Your name"
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                fullWidth
                required
                name="testimonial"
                component={TextField}
                variant="outlined"
                multiline
                minRows={4}
                label="Your review"
              />
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                type="submit"
                fullWidth
                disabled={submitting}
                startIcon={submitting ? <CircularProgress size={18} color="inherit" /> : null}
              >
                {submitting ? 'Sending…' : 'Submit review'}
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
}
